import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { Cohorts } from '@/constants/cohorts';
import styles from './HeaderListCohortListExpandable.module.scss';

interface IHeaderListCohortListExpandable {
  active: boolean;
  children: React.ReactNode | React.ReactNode[];
  cohort: Cohorts | '';
  index: number;
  label: string;
  mobile: boolean; // just checks for mobile navigation being open to infer
  name: string;
  open: number | null;
  setOpen: React.Dispatch<React.SetStateAction<number | null>>;
  setCohort: React.Dispatch<React.SetStateAction<Cohorts | ''>>;
  onHeightChange: (height: number) => void;
}

export const HeaderListCohortListExpandable = ({
  active,
  children,
  cohort,
  index,
  label,
  name,
  open,
  setOpen,
  setCohort,
  mobile,
  onHeightChange,
}: IHeaderListCohortListExpandable) => {
  const router = useRouter();
  const liRef = useRef<HTMLLIElement>(null);
  const menuDivRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const li = liRef.current;
    const menuDiv = menuDivRef.current;
    if (!li || !menuDiv) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      const height = menuDiv.clientHeight;
      if (height > 0) {
        onHeightChange(height + li.clientHeight);
      }
    });
    resizeObserver.observe(menuDiv);
    return () => {
      resizeObserver.disconnect();
    };
  }, [onHeightChange]);

  return (
    <li
      ref={liRef}
      className={`
          ${styles['menu-item-expandable']}
          ${index === open ? styles.expanded : ''}`}
      role="menuitem"
    >
      <button
        aria-expanded={index === open}
        aria-controls={`section-${name}`}
        aria-label={name}
        id={`id-collapse-${name}`}
        className={`${styles.button} ${active ? styles.active : ''}`}
        onClick={() => {
          setCohort(cohort);
          if (!mobile) {
            if (cohort === Cohorts.HOME_OWNERS) {
              router.push('/');
            } else if (cohort === Cohorts.INVESTORS) {
              router.push('/investors');
            } else if (cohort === Cohorts.TAILORED) {
              router.push('/tailored');
            }
          }
          setOpen(index);
        }}
        onFocus={() => {
          setOpen(index);
        }}
        onMouseEnter={() => {
          if (mobile) return;
          setOpen(index);
        }}
        type="button"
      >
        {label}
      </button>
      <div aria-labelledby={`id-collapse-${name}`} className={styles.collapse} id={`section-${name}`} role="region">
        <div ref={menuDivRef} className={styles.container}>
          <div className={styles.menu}>{children}</div>
        </div>
      </div>
    </li>
  );
};
